import {
	designTokens,
	RiArrowRightSLine,
	RiLock2Line
} from "@itandi/itandi-bb-ui";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import type React from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { UserLoginModalPassword } from "~/components/common/user_login_modal/UserLoginModalPassword";
import type { NskResponse } from "~/models/Api";
import { isSuccess } from "~/utils/api/api_handler";
import Styles from "./UserLoginModal.module.scss";

// VendorUserとStaffが利用する想定
export type LoginStaffModel = {
	email: string | null;
	hasPassword: boolean;
	id: number;
	name: string;
};

type Props = {
	handleLogin: (id: number, password: string | null) => Promise<NskResponse>;
	loginStaffs: LoginStaffModel[];
	mutateSession: () => Promise<void>;
};

export function UserLoginModal({
	loginStaffs,
	handleLogin,
	mutateSession
}: Props) {
	const [selectedUser, setSelectedUser] = useState<LoginStaffModel | null>(
		null
	);
	const onBackToList = (): void => {
		setSelectedUser(null);
	};

	const renderRow = (loginUser: LoginStaffModel): React.ReactElement => {
		const onClickRow = async (): Promise<void> => {
			if (loginUser.hasPassword) {
				setSelectedUser(loginUser);
				return;
			}
			const result = await handleLogin(loginUser.id, null);
			if (isSuccess(result)) {
				await mutateSession();
				toast.success("ログインしました。");
				return;
			}
			toast.error(`エラーが発生しました。${result.message ?? ""}`);
		};
		return (
			<button
				className={Styles.UserLink}
				key={loginUser.id}
				onClick={onClickRow}
				type="button"
			>
				<Grid gap={designTokens["spacing/xxs"]}>
					<div>{loginUser.name}</div>
					{loginUser.email ? (
						<div>
							<Label color="subtle">{loginUser.email}</Label>
						</div>
					) : null}
				</Grid>
				<Flex alignItems="center" gap={designTokens["spacing/xxxs"]} ml="auto">
					{loginUser.hasPassword ? (
						<RiLock2Line className={Styles.LockIcon} />
					) : null}
					<RiArrowRightSLine className={Styles.ArrowIcon} />
				</Flex>
			</button>
		);
	};

	return (
		<Modalv2 isOpen onClose={() => {}} size={selectedUser ? "s" : undefined}>
			<ModalHeader
				title={
					selectedUser !== null
						? `${selectedUser.name}でログイン`
						: "担当者ログイン"
				}
			/>
			{selectedUser !== null ? (
				<UserLoginModalPassword
					loginUser={selectedUser}
					mutateSession={mutateSession}
					onBack={onBackToList}
					onLogin={handleLogin}
				/>
			) : (
				<ModalBody>{loginStaffs.map(renderRow)}</ModalBody>
			)}
		</Modalv2>
	);
}
